// extracted by mini-css-extract-plugin
export default {"App":"TDex_App__fFB0X","body":"TDex_body__gVat4"};